// SPDX-License-Identifier: AGPL-3.0-or-later

const NEW_API_ORIGIN = 'https://api.lafon.com.tr';
const LEGACY_API_HOST_PATTERN = /https?:\/\/(?:www\.)?(?:api\.)?mictro\.com(?=[/?#]|$)/giu;

/** Rewrites legacy Mictro API hosts so catalog media loads under CSP for api.lafon.com.tr. */
export function rewriteLegacyApiHostUrl(value: string): string {
	return value.replace(LEGACY_API_HOST_PATTERN, NEW_API_ORIGIN);
}
